import { SupportedLanguages } from '../config';
import { supportedLanguagesRegExp } from './supportedLanguagesRegExp';

/** Получает код языка из url. Возвращает язык, только если он поддерживается!
 *
 */
export const extractLanguageFromUrl = (url: string): SupportedLanguages | undefined => {
  const search = url.match(supportedLanguagesRegExp);
  if (!search) return undefined;
  return search[0].replace(/\//g, '') as SupportedLanguages;
};
